import uiRouter from '@uirouter/angularjs';
import * as ng from 'angular';
import 'angular-animate';
import 'angular-aria';
import 'angular-jwt';
import 'angular-storage';
import { AppComponent } from './app.component';
import { ServicesModule } from './services/services.module';
import './app.scss';
import { DEBUG } from './config';
import { AppConstants, IAppConstants } from './app.constants';
import 'chart.js';
import 'angular-chart.js';
import 'angular-smart-table';
import 'angular-ui-bootstrap';
import 'angular-breadcrumb';
import './third/ui-select/dist/select.js';
import './third/fileSaver';
import { appRun } from './app.run';
import { AppController } from './app.controller';
import { SectionsModule } from './sections/sections.module';
import { DirectivesModule } from './commons/directives/directives.module';
import { FiltersModule } from './filters/filters.module';
import * as $ from 'jquery';
import { PreviewModalModule } from './preview-modal/preview-modal.module';
import { UserSettingsModule } from './sections/usersettings/usersettings.module';
import { ComponentsModule } from './commons/components/components.module';
import { SmartTableModule } from './third/smart-table/smart-table.module';
import { TransitionService } from 'angular-ui-router';

let config = (
    configuration: IAppConstants,
    $logProvider: ng.ILogProvider,
    $stateProvider: ng.ui.IStateProvider,
    $urlRouterProvider: ng.ui.IUrlRouterProvider,
    jwtInterceptorProvider: ng.jwt.IJwtInterceptor,
    jwtOptionsProvider: any,
    $httpProvider: ng.IHttpProvider,
    $provide: any,
    uibDatepickerConfig: ng.ui.bootstrap.IDatepickerConfig,
    uibDatepickerPopupConfig: ng.ui.bootstrap.IDatepickerPopupConfig,
    $locationProvider: ng.ILocationProvider,
    $transitions: TransitionService
) => {
    uibDatepickerConfig.showWeeks = false;
    uibDatepickerPopupConfig.showButtonBar = false;
    uibDatepickerConfig.startingDay = 1;
    $urlRouterProvider.otherwise('login');
    jwtInterceptorProvider.tokenGetter = (store: ng.a0.storage.IStoreService) => {
        return (store.get('jwt')) ? store.get('jwt') : store.get('registrationJWT');
    };
    jwtOptionsProvider.config({
        whiteListedDomains: [configuration.restServer],
    });
    $httpProvider.interceptors.push('jwtInterceptor');

    /*
    var cacheBuster = "v=x.y.z";
        function templateFactoryDecorator($delegate) {
            var fromUrl = angular.bind($delegate, $delegate.fromUrl);
            $delegate.fromUrl = function (url, params) {
                if (url !== null && angular.isDefined(url) && angular.isString(url)) {
                    url += (url.indexOf("?") === -1 ? "?" : "&");
                    url += cacheBuster;
                }

                return fromUrl(url, params);
            };
            return $delegate;
        }

        $provide.decorator('$templateFactory', ['$delegate', templateFactoryDecorator]);
    */

    $locationProvider.html5Mode(true); // .hashPrefix('!');
    $logProvider.debugEnabled(DEBUG);
};

config.$inject = [
    'configuration',
    '$logProvider',
    '$stateProvider',
    '$urlRouterProvider',
    'jwtInterceptorProvider',
    'jwtOptionsProvider',
    '$httpProvider',
    '$provide',
    'uibDatepickerConfig',
    'uibDatepickerPopupConfig',
    '$locationProvider',
    '$transitionsProvider'
];


const root: string = ng
    .module('app', [
        'angular-jwt',
        'angular-storage',
        'ngAnimate',
        'ngAria',
        'chart.js',
        'smart-table',
        'ui.bootstrap',
        'ncy-angular-breadcrumb',
        'ui.select',
        uiRouter,
        ServicesModule,
        SectionsModule,
        DirectivesModule,
        ComponentsModule,
        FiltersModule,
        PreviewModalModule,
        UserSettingsModule,
        SmartTableModule
    ])
    .constant('configuration', AppConstants)
    .component('app', AppComponent)
    .controller('AppController', AppController)
    .config(config)
    .run(appRun)
    .name;


export { root };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/app.module.ts